<template>
  <label
    class="d-flex align-items-center"
    :data-cy="testId"
    @click="($event) => $emit('click', $event)"
  >
    <div
      class="checkbox-container w-4 h-4 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 mr-1"
      data-cy="checkbox-container"
      :class="{
        'text-white bg-red-300 border-red-700 border-2': error,
        'text-white bg-blue-700 border-blue-700': checked,
        'text-blue-700 bg-gray-100 border-gray-300': !checked,
        disabled
      }"
    >
      <Transition>
        <i v-if="checked" data-cy="checked-checkbox" class="fas fa-check"></i>
      </Transition>
      <input
        v-model="checked"
        type="checkbox"
        class="custom-checkbox"
        :disabled="disabled"
      />
    </div>
    {{ label }}
  </label>
</template>

<script>
import { kebabCase } from "@/lib/helpers.js";

import Transition from "./Transition.vue";

export default {
  name: "Checkbox",
  components: {
    Transition
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "click"],
  computed: {
    checked: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    },
    testId() {
      return kebabCase(this.label) || "checkbox";
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox-container {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9em;
  height: 1.8em;
  width: 1.8em;
  border: 1px solid #ced4da;
  border-radius: 3px;
  background: white;
  color: white;
  cursor: pointer;
  transition: background 200ms ease-out;
  box-shadow: none;

  &.active {
    background: var(--primary-color);
    border-color: var(--primary-color);
  }
  &.disabled {
    background: var(--light-gray);
    border-color: var(--light-gray);
    color: var(--text-color);
    cursor: default;
    opacity: 0.7;
  }
  &.error {
    border: 2px solid var(--danger);
  }
}

.custom-checkbox {
  display: none;
}
</style>
